import { render, staticRenderFns } from "./NoticeCard.vue?vue&type=template&id=89d0d3cc&scoped=true&"
import script from "./NoticeCard.vue?vue&type=script&lang=js&"
export * from "./NoticeCard.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCard.vue?vue&type=style&index=0&id=89d0d3cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0d3cc",
  null
  
)

export default component.exports